export default __webpack_public_path__ + "static/media/Torque.b8691dd1.svg";